// const newLocation = `https://api.${process.env.VUE_APP_ENV}.fygr.io`;

const routes = [
  // {
  //   path: '/oauth2/pkce/getOauthRedirectUrl',
  //   name: 'oauth-api',
  //   beforeEnter(to, from, next) { // eslint-disable-line no-unused-vars
  //     window.location.replace(newLocation + to.fullPath);
  //   },
  // },
  {
    path: '/oauth2/authorize',
    name: 'oauth-authorize',
    meta: {layout: 'no-auth'},
    component: () => import('@/components/pages/auth/OauthAuthorize.vue'),
  },
  {
    path: '/passwordrecovery',
    name: 'oauth-password-recovery',
    meta: {layout: 'no-auth'},
    component: () => import('@/components/pages/PasswordRecovery.vue'),
  },
  {
    path: '/fygrclosewindow',
    name: 'oauth-password-recovery-close',
    meta: {layout: 'no-auth'},
    component: () => import('@/components/pages/PasswordRecovery.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'oauth-error',
    meta: {layout: 'no-auth'},
    component: () => import('@/components/pages/auth/OauthNotFound.vue'),
  },
];

export default routes;
